import { PERMISSIONS } from "../../constants/permissions";
import { USER_TYPES } from "../../constants/user-types";
import Icons from "../../icons/sidebar";
import { MenuCategories } from "./MenuCategories";

export interface IGroupMenu extends IMenuItem {
  isGroup?: boolean;
  menuItems?: IMenuItem[];
  permissions?: string[];
  users?: string[];
}

export interface IMenuItem {
  title: string;
  Icon?: any;
  hasNewFeature?: boolean;
  path: string;
  subMenu?: IMenuItem[] | IGroupMenu[];
  permissions?: string[];
  users?: string[];
  categories?: string[];
  category?: string;
}

const MenuList: IMenuItem[] = [
  {
    title: "Dashboard",
    Icon: Icons.SpeedIcon,
    path: "/dashboard",
    users: [
      USER_TYPES.INSTITUTION_ADMIN,
      USER_TYPES.STAFF,
      USER_TYPES.SYSTEM_USER,
      USER_TYPES.MASTER_ADMIN,
    ],
  },
  {
    title: "Clients",
    Icon: Icons.GroupsIcon,
    path: "/clients",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [PERMISSIONS.VIEW_CLIENTS],
    subMenu: [
      {
        path: "/clients/individual",
        title: "Individual",
      },
      {
        path: "/clients/institution",
        title: "Institution",
      },
      {
        path: "/clients/group",
        title: "Group",
      },
    ],
  },
  {
    title: "Loans",
    Icon: Icons.PaidIcon,
    path: "/loans",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [PERMISSIONS.VIEW_LOANS],
    subMenu: [
      {
        path: "/loans/create-loan",
        title: "Add New Loan",
        permissions: [PERMISSIONS.ADD_LOANS],
      },
      {
        path: "/loans/drafts",
        title: "Drafts",
        permissions: [
          PERMISSIONS.ADD_LOANS,
          PERMISSIONS.APPROVE_LOANS,
          PERMISSIONS.DECLINE_LOANS,
        ],
      },
      {
        path: "/loans/applications",
        title: "Applications",
        permissions: [
          PERMISSIONS.ADD_LOANS,
          PERMISSIONS.APPROVE_LOANS,
          PERMISSIONS.DECLINE_LOANS,
        ],
      },
      {
        path: "/loans/disbursement",
        title: "Pending Disbursement",
        permissions: [PERMISSIONS.DISBURSE_LOANS],
      },
      {
        path: "/loans/active",
        title: "Active Loans",
      },
      {
        path: "/loans/declined",
        title: "Declined",
      },
      {
        path: "/loans/closed",
        title: "Closed",
      },
      {
        path: "/loans/written-off-loans",
        title: "Written Off Loans",
      },
      {
        path: "loans/calculator",
        title: "Loan Calculator",
        isGroup: true,
        menuItems: [
          {
            path: "/loans/loan-term-calculator",
            title: "Loan Term Calculator",
            permissions: [],
          },
          {
            path: "/loans/loan-eligibility-calculator",
            title: "Loan Eligibility Calculator",
            permissions: [
              PERMISSIONS.VIEW_LOAN_ELIGIBILITY_CALCULATOR,
              PERMISSIONS.CHECK_LOAN_ELIGIBILITY,
            ],
          },
        ],
      },
      {
        path: "/loans/collateral",
        title: "Collateral  Register",
        permissions: [PERMISSIONS.VIEW_LOAN_COLLATERALS],
      },
      {
        path: "/loans/loan-agreement-credits",
        title: "Loan Agreement Credits",
        permissions: [
          PERMISSIONS.PURCHASE_LOAN_AGREEMENT_CREDITS,
          PERMISSIONS.VIEW_LOAN_AGREEMENT_CREDITS_PURCHASES,
        ],
      },
      {
        path: "/loans/loan-agreement-credits-balances",
        title: "Loan Agreement Credit Balances",
        permissions: [PERMISSIONS.VIEW_LOAN_AGREEMENT_CREDITS_PURCHASES],
      },
    ],
  },
  {
    title: "Savings",
    Icon: Icons.SavingsIcon,
    path: "/savings",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [PERMISSIONS.MANAGE_SAVINGS],
    subMenu: [
      {
        path: "/savings/deposit",
        title: "Register Deposit",
        permissions: [PERMISSIONS.CLIENT_ADD_DEPOSIT],
      },
      {
        path: "/savings/withdraw",
        title: "Register Withdraw",
        permissions: [PERMISSIONS.CLIENT_ADD_WITHDRAWAL],
      },
      {
        path: "/savings/deposit-transactions",
        title: "Deposit Transactions",
        permissions: [PERMISSIONS.CLIENT_ADD_DEPOSIT],
      },
      {
        path: "/savings/withdraw-transactions",
        title: "Withdraw Transactions",
        permissions: [PERMISSIONS.CLIENT_ADD_WITHDRAWAL],
      },
      {
        path: "/savings/fixed-deposit",
        title: "Fixed Deposit Calculator",
        permissions: [PERMISSIONS.CLIENT_ADD_FIXEDDEPOSIT],
      },
      {
        path: "/savings/disburse-interest",
        title: "Disburse Interest",
        permissions: [PERMISSIONS.DISRBUSE_INTEREST],
      },
    ],
  },
  {
    title: "Shares",
    Icon: Icons.BalanceIcon,
    path: "/shares",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [PERMISSIONS.VIEW_SHARES],
    subMenu: [
      {
        path: "/shares/register",
        title: "Shares Register",
        permissions: [PERMISSIONS.VIEW_SHARES],
      },
      {
        path: "/shares/share-purchase",
        title: "Purchase Shares",
        permissions: [PERMISSIONS.ADD_PURCHASE_SHARES],
      },
      {
        path: "/shares/share-transfer",
        title: "Transfer Shares",
        permissions: [PERMISSIONS.ADD_TRANSFER_SHARES],
      },
      {
        path: "/shares/purchase-transactions",
        title: "Share Purchases",
        permissions: [PERMISSIONS.VIEW_PURCHASE_SHARES],
      },
      {
        path: "/shares/transfer-transactions",
        title: "Share Transfers",
        permissions: [PERMISSIONS.VIEW_TRANSFER_SHARES],
      },
      {
        path: "/shares/share-sell",
        title: "Sell Shares",
        permissions: [],
      },
      {
        path: "/shares/dividends",
        title: "Dividends",
        permissions: [PERMISSIONS.VIEW_TRANSFER_SHARES],
      },
    ],
  },
  {
    title: "Assets",
    Icon: Icons.WebAssetIcon,
    path: "/assets",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [
      PERMISSIONS.VIEW_PHYSICAL_ASSETS,
      PERMISSIONS.VIEW_NON_PHYSICAL_ASSETS,
    ],
    subMenu: [
      {
        path: "/assets/physical",
        title: "Physical Assets",
        permissions: [PERMISSIONS.VIEW_PHYSICAL_ASSETS],
      },
      {
        path: "/assets/non-physcial",
        title: "Non Physical",
        permissions: [PERMISSIONS.VIEW_NON_PHYSICAL_ASSETS],
      },
    ],
  },
  {
    title: "Accounting",
    Icon: Icons.CalculateIcon,
    path: "/accounting",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [
      PERMISSIONS.VIEW_ACCOUNTS,
      PERMISSIONS.VIEW_TILL_SHEET,
      PERMISSIONS.VIEW_SUPPLIERS,
      PERMISSIONS.VIEW_RECEIVABLES,
      PERMISSIONS.VIEW_DEBTORS,
      PERMISSIONS.VIEW_PAYABLES,
      PERMISSIONS.VIEW_CREDITORS,
      PERMISSIONS.VIEW_CASH_TRANSFERS,
      PERMISSIONS.ADD_CASH_TRANSFERS,
      PERMISSIONS.ADD_STAFF_CASH_ACCOUNTS,
      PERMISSIONS.ADD_STAFF_BANK_ACCOUNTS,
      PERMISSIONS.ADD_STAFF_SAFE_ACCOUNTS,
    ],
    subMenu: [
      {
        path: "/accounting/chart-of-accounts",
        title: "Accounting",
        permissions: [PERMISSIONS.VIEW_CHART_OF_ACCOUNTS],
      },
      {
        path: "/accounting/transaction-accounts",
        title: "Transaction Accounts",
        permissions: [
          PERMISSIONS.ADD_STAFF_CASH_ACCOUNTS,
          PERMISSIONS.ADD_STAFF_BANK_ACCOUNTS,
          PERMISSIONS.ADD_STAFF_SAFE_ACCOUNTS,
          PERMISSIONS.VIEW_STAFF_SAFE_ACCOUNTS,
          PERMISSIONS.VIEW_STAFF_BANK_ACCOUNTS,
          PERMISSIONS.VIEW_STAFF_CASH_ACCOUNTS,
          PERMISSIONS.VIEW_STAFF_BANK_ACCOUNT_STATEMENT,
          PERMISSIONS.VIEW_STAFF_SAFE_ACCOUNT_STATEMENT,
          PERMISSIONS.VIEW_STAFF_MOBILE_MONEY_ACCOUNTS,
          PERMISSIONS.VIEW_ZIMBA_ACCOUNT_WALLETS,
        ],
      },
      {
        path: "/accounting/cash-transfers",
        title: "Cash Transfers",
        permissions: [
          PERMISSIONS.VIEW_CASH_TRANSFERS,
          PERMISSIONS.ADD_CASH_TRANSFERS,
        ],
      },
      {
        path: "/accounting/payables",
        title: "Payables",
        permissions: [PERMISSIONS.VIEW_PAYABLES, PERMISSIONS.VIEW_CREDITORS],
      },
      {
        path: "/accounting/receivables",
        title: "Recievables",
        permissions: [PERMISSIONS.VIEW_RECEIVABLES, PERMISSIONS.VIEW_DEBTORS],
      },
      {
        path: "/accounting/suppliers",
        title: "Suppliers",
        permissions: [PERMISSIONS.VIEW_SUPPLIERS],
      },
      {
        path: "/accounting/staff-till-sheet",
        title: "Staff Till Sheet",
        permissions: [PERMISSIONS.VIEW_TILL_SHEET],
      },
    ],
  },
  {
    title: "SMS Banking",
    Icon: Icons.SmsIcon,
    path: "/sms-banking",
    users: [
      USER_TYPES.INSTITUTION_ADMIN,
      USER_TYPES.STAFF,
      USER_TYPES.SYSTEM_USER,
    ],
    permissions: [PERMISSIONS.MANAGE_SMS_SETTINGS, PERMISSIONS.VIEW_OUTBOX],
    subMenu: [
      {
        path: "/sms-banking/settings",
        title: "Settings",
        permissions: [PERMISSIONS.MANAGE_SMS_SETTINGS],
      },
      {
        path: "/sms-banking/outbox",
        title: "Outbox",
        permissions: [PERMISSIONS.VIEW_OUTBOX],
      },
    ],
  },
  {
    title: "Know Your Customer",
    Icon: Icons.PersonSearchIcon,
    path: "/kyc",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [
      PERMISSIONS.VIEW_KYC_PURCHASES,
      PERMISSIONS.VIEW_KYC_CHECK_CREDIT,
      PERMISSIONS.VIEW_KYC_CHECK_SCORE,
      PERMISSIONS.VIEW_KYC_PHONE_NUMBER,
      PERMISSIONS.VIEW_KYC_VALIDATE_NIN,
      PERMISSIONS.VIEW_KYC_VALIDATE_ID,
      PERMISSIONS.VIEW_KYC_STATS,
      PERMISSIONS.VIEW_CRB_EXTRACTION_CREDITS_PURCHASE,
      PERMISSIONS.VIEW_CRB_EXTRACTION_HISTORY,
      PERMISSIONS.PURCHASE_CRB_EXTRACTION_CREDITS,
    ],
    subMenu: [
      {
        path: "/kyc/services",
        title: "KYC Services",
        permissions: [
          PERMISSIONS.VIEW_KYC_PURCHASES,
          PERMISSIONS.VIEW_CRB_EXTRACTION_CREDITS_PURCHASE,
          PERMISSIONS.VIEW_CRB_EXTRACTION_HISTORY,
          PERMISSIONS.PURCHASE_CRB_EXTRACTION_CREDITS,
        ],
      },
      {
        path: "/kyc/checks",
        title: "KYC Check",
        permissions: [
          PERMISSIONS.VIEW_KYC_CHECK_CREDIT,
          PERMISSIONS.VIEW_KYC_CHECK_SCORE,
          PERMISSIONS.VIEW_KYC_PHONE_NUMBER,
          PERMISSIONS.VIEW_KYC_VALIDATE_NIN,
          PERMISSIONS.VIEW_KYC_VALIDATE_ID,
        ],
      },
    ],
  },
  {
    title: "Workflow Requests",
    path: "/workflow-requests",
    Icon: Icons.SchemaIcon,
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [
      PERMISSIONS.VIEW_WORKFLOW_REQUEST,
      PERMISSIONS.ADD_WORKFLOW_REQUEST,
    ],
  },
  {
    title: "Data Importer",
    Icon: Icons.DriveFolderUploadIcon,
    path: "/data-importer",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [PERMISSIONS.VIEW_BATCH_IMPORT],
    subMenu: [
      {
        path: "/data-importer/import-clients",
        title: "Clients",
        permissions: [PERMISSIONS.IMPORT_CLIENTS],
      },
      {
        path: "/data-importer/import-expenses",
        title: "Expenses",
        permissions: [PERMISSIONS.IMPORT_EXPENSES],
      },
      {
        path: "/data-importer/import-loans",
        title: "Loans",
        permissions: [PERMISSIONS.IMPORT_LOANS],
      },
      {
        path: "/data-importer/import-loan-payments",
        title: "Loan Payments",
        permissions: [PERMISSIONS.IMPORT_LOANS],
      },
      {
        path: "/data-importer/import-savings-transactions",
        title: "Savings Transactions",
        permissions: [PERMISSIONS.IMPORT_CLIENT_ACCOUNTS],
      },
      {
        path: "/data-importer/import-client-accounts",
        title: "Client Accounts",
        permissions: [PERMISSIONS.IMPORT_CLIENT_ACCOUNTS],
      },
      {
        path: "/data-importer/import-shares",
        title: "Shares",
        permissions: [PERMISSIONS.IMPORT_SHARES],
      },
      {
        path: "/data-importer/import-share-purchases",
        title: "Share Purchases",
        permissions: [PERMISSIONS.IMPORT_SHARE_PURCHASES],
      },
      {
        path: "/data-importer/import-coa",
        title: "Chart of Accounts",
        permissions: [PERMISSIONS.IMPORT_CHART_OF_ACCOUNTS],
      },
      {
        path: "/data-importer/import-payroll-reconciliations",
        title: "Payroll Reconciliations",
        permissions: [PERMISSIONS.IMPORT_PAYROLL_RECONCILIATIONS],
      },
    ],
  },
  {
    title: "Reports",
    Icon: Icons.StackedLineChartIcon,
    path: "/reports",
    users: [
      USER_TYPES.INSTITUTION_ADMIN,
      USER_TYPES.STAFF,
      USER_TYPES.MASTER_ADMIN,
    ],
    permissions: [
      PERMISSIONS.REPORT_ADHOC,
      PERMISSIONS.REPORT_BALANCE_SHEET,
      PERMISSIONS.REPORT_TRIAL_BALANCE,
      PERMISSIONS.REPORT_INCOME_STATEMENT,
      PERMISSIONS.REPORT_AGEING,
      PERMISSIONS.REPORT_ARREARS,
      PERMISSIONS.REPORT_STATUS,
      PERMISSIONS.REPORT_DISBURSEMENT,
      PERMISSIONS.REPROT_PORTFOLIO,
      PERMISSIONS.REPORT_CUMMULATIVE_REPAYMENTS,
      PERMISSIONS.REPORT_LOAN,
      PERMISSIONS.REPORT_MEMBERSHIP,
      PERMISSIONS.REPORT_EXPENSE,
      PERMISSIONS.REPORT_FEES,
      PERMISSIONS.REPORT_OFFICER,
      PERMISSIONS.REPORT_SAVINGS,
      PERMISSIONS.REPORT_PHYSICAL_ASSET,
      PERMISSIONS.REPORT_CUMULATE_SAVINGS,
      PERMISSIONS.REPORT_SAVINGS_OFFICER,
      PERMISSIONS.REPORT_SUMMARY_COLLECTION,
      PERMISSIONS.REPORT_LOAN_BOOK,
      PERMISSIONS.REPORT_PHYSICAL_ASSET,
      PERMISSIONS.REPORT_EXPECTED_LOAN_PAYMENT_SUMMARY,
    ],
    subMenu: [
      {
        isGroup: true,
        title: "Financial Reports",
        path: "financial-report-group",
        permissions: [
          PERMISSIONS.REPORT_BALANCE_SHEET,
          PERMISSIONS.REPORT_TRIAL_BALANCE,
          PERMISSIONS.REPORT_INCOME_STATEMENT,
          PERMISSIONS.REPORT_EXPENSE,
          PERMISSIONS.REPORT_FEES,
        ],
        menuItems: [
          {
            path: "/reports/balance-sheet",
            title: "Balance Sheet",
            permissions: [PERMISSIONS.REPORT_BALANCE_SHEET],
          },
          {
            path: "/reports/trial-balance",
            title: "Trial Balance",
            permissions: [PERMISSIONS.REPORT_TRIAL_BALANCE],
          },
          {
            path: "/reports/income-statement",
            title: "Income Statement",
            permissions: [PERMISSIONS.REPORT_INCOME_STATEMENT],
          },
          {
            path: "/reports/cashflow-statement",
            title: "Cashflow Statement",
            permissions: [PERMISSIONS.REPORT_CASHFLOW_STATEMENT],
          },
          {
            path: "/reports/expenses-report",
            title: "Expenses Report",
            permissions: [PERMISSIONS.REPORT_EXPENSE],
          },
          {
            path: "/reports/fees-report",
            title: "Fees Report",
            permissions: [PERMISSIONS.REPORT_FEES],
          },
        ],
      },
      {
        isGroup: true,
        title: "Loan Reports",
        path: "loan-reports-group",
        permissions: [
          PERMISSIONS.REPORT_AGEING,
          PERMISSIONS.REPORT_ARREARS,
          PERMISSIONS.REPORT_STATUS,
          PERMISSIONS.REPORT_DISBURSEMENT,
          PERMISSIONS.REPROT_PORTFOLIO,
          PERMISSIONS.REPORT_CUMMULATIVE_REPAYMENTS,
          PERMISSIONS.REPORT_LOAN_REPAYMENTS,
          PERMISSIONS.REPORT_OFFICER,
          PERMISSIONS.REPORT_SUMMARY_COLLECTION,
          PERMISSIONS.REPORT_SAVINGS,
          PERMISSIONS.REPORT_LOAN_BOOK,
          PERMISSIONS.REPORT_LOAN,
          PERMISSIONS.REPORT_EXPECTED_LOAN_REPAYMENT,
          PERMISSIONS.REPORT_LOAN_OFFICER_PORTFOLIO_BALANCE,
        ],
        hasNewFeature: true,
        menuItems: [
          {
            path: "/reports/ageing-report",
            title: "Aging Report",
            permissions: [PERMISSIONS.REPORT_AGEING],
          },
          {
            path: "/reports/loan-arrears-report",
            title: "Loan Arrears Report",
            permissions: [PERMISSIONS.REPORT_ARREARS],
          },
          {
            path: "/reports/loan-status-report",
            title: "Loan Status Report",
            permissions: [PERMISSIONS.REPORT_STATUS],
          },
          {
            path: "/reports/loan-disbursement-report",
            title: "Loan Disbursement Report",
            permissions: [PERMISSIONS.REPORT_DISBURSEMENT],
          },
          {
            path: "/reports/portfolio-at-risk-report",
            title: "Portfolio At Risk Report",
            permissions: [PERMISSIONS.REPROT_PORTFOLIO],
          },
          {
            path: "/reports/loan-repayment-report",
            title: "Cumulative Loan Repayment",
            permissions: [PERMISSIONS.REPORT_CUMMULATIVE_REPAYMENTS],
          },
          {
            path: "/reports/loan-officer-report",
            title: "Loan Officer Report",
            permissions: [PERMISSIONS.REPORT_OFFICER],
          },
          {
            path: "/reports/loan-officer-summary-report",
            title: "Loan Officer Summary Report",
            permissions: [PERMISSIONS.REPORT_OFFICER],
          },
          {
            path: "/reports/summary-collection-report",
            title: "Summary Collection",
            permissions: [PERMISSIONS.REPORT_SUMMARY_COLLECTION],
          },
          {
            path: "/reports/par-aging-report",
            title: "Par Aging Report",
            permissions: [PERMISSIONS.REPORT_AGEING],
          },
          {
            path: "/reports/loan-book-report",
            title: "Loan Book Report",
            permissions: [PERMISSIONS.REPORT_LOAN_BOOK],
          },
          {
            path: "/reports/expected-loan-repayment-report",
            title: "Expected Loan Repayment Report",
            permissions: [PERMISSIONS.REPORT_EXPECTED_LOAN_REPAYMENT],
          },
          {
            path: "/reports/loan-expected-payment-summary-report",
            title: "Expected Payment Summary Report",
            permissions: [PERMISSIONS.REPORT_EXPECTED_LOAN_PAYMENT_SUMMARY],
          },
          {
            path: "/reports/loan-repayment-transaction-report",
            title: "Loan Repayment Report",
            permissions: [PERMISSIONS.REPORT_LOAN_REPAYMENTS],
          },
          {
            path: "/reports/loan-officer-portfolio-balance-summary-report",
            title: "Loan Officer Portfolio Balance Summary Report",
            permissions: [PERMISSIONS.REPORT_LOAN_OFFICER_PORTFOLIO_BALANCE],
          },
          {
            path: "/reports/branch-portfolio-balance-summary-report",
            title: "Branch Portfolio Balance Summary Report",
            permissions: [PERMISSIONS.REPORT_BRANCH_PORTFOLIO_SUMMARY],
          },
        ],
      },
      {
        isGroup: true,
        title: "Savings Reports",
        path: "savings-report-group",
        permissions: [
          PERMISSIONS.REPORT_SAVINGS,
          PERMISSIONS.REPORT_CUMULATE_SAVINGS,
          PERMISSIONS.REPORT_SAVINGS_OFFICER,
        ],
        menuItems: [
          {
            path: "/reports/savings-report",
            title: "Savings Report",
            permissions: [PERMISSIONS.REPORT_SAVINGS],
          },
          {
            path: "/reports/cumulative-savings-report",
            title: "Cumulative Savings Report",
            permissions: [PERMISSIONS.REPORT_CUMULATE_SAVINGS],
          },
          {
            path: "/reports/savings-officer-report",
            title: "Savings Officer Report",
            permissions: [PERMISSIONS.REPORT_SAVINGS_OFFICER],
          },
        ],
      },
      {
        isGroup: true,
        title: "Client Reports",
        path: "client-report-group",
        permissions: [PERMISSIONS.REPORT_MEMBERSHIP, PERMISSIONS.REPORT_LOAN],
        menuItems: [
          {
            path: "/reports/membership-schedule",
            title: "Shareholder Report",
            permissions: [PERMISSIONS.REPORT_MEMBERSHIP],
          },
          {
            path: "/reports/client-report",
            title: "Client Report",
            permissions: [PERMISSIONS.REPORT_LOAN],
          },
        ],
      },
      {
        isGroup: true,
        title: "Asset Reports",
        path: "physical-asset-report",
        menuItems: [
          {
            path: "/reports/physical-asset-report",
            title: "Physical Asset Report",
            permissions: [PERMISSIONS.REPORT_PHYSICAL_ASSET],
          },
          {
            path: "/reports/physical-asset-sale-report",
            title: "Physical Asset Sale Report",
            permissions: [PERMISSIONS.REPORT_PHYSICAL_ASSET_SALES],
          },
          {
            path: "/reports/non-physical-asset-report",
            title: "Non Physical Asset Report",
            permissions: [PERMISSIONS.REPORT_NON_PHYSICAL_ASSETS],
          },
        ],
      },
      {
        isGroup: true,
        title: "Adhoc Reports",
        users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
        path: "adhoc-reports",
        menuItems: [
          {
            path: "/reports/adhoc-reports",
            title: "Adhoc Reports",
            users: [USER_TYPES.INSTITUTION_ADMIN],
            permissions: [],
          },
        ],
      },
    ],
  },
  {
    title: "Analytics",
    Icon: Icons.AnalyticsIcon,
    path: "/analytics",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [
      PERMISSIONS.ANALYTICS_SAVINGS_PRODUCTS_PERFORMANCE,
      PERMISSIONS.ANALYTICS_DEPOSIT_TRENDS,
      PERMISSIONS.ANALYTICS_TOP_LOAN_PERFORMANCE,
      PERMISSIONS.ANALYTICS_LOAN_REPAYMENT,
      PERMISSIONS.ANALYTICS_LOAN_DELINQUENCY,
      PERMISSIONS.ANALYTICS_LOAN_PORTFOLIO,
      PERMISSIONS.ANALYTICS_CUSTOMER_SEGMENTATION,
      PERMISSIONS.ANALYTICS_CUSTOMER_RETENTION_AND_CHURN,
      PERMISSIONS.ANALYTICS_REFERRAL_TRACKING,
      PERMISSIONS.ANALYTICS_REVENUE_PERFORMANCE,
      PERMISSIONS.ANALYTICS_EXPENSE_TRACKING,
      PERMISSIONS.ANALYTICS_PROFIT_MARGIN,
      PERMISSIONS.ANALYTICS_PRODUCT_PERFORMANCE,
      PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_PERFORMANCE,
      PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_GOAL_SETTINGS,
      PERMISSIONS.ANALYTICS_RISK_EXPOSURE_ASSESSMENT,
    ],
    subMenu: [
      {
        isGroup: true,
        title: "Customer",
        path: "customer-analytics-group",
        permissions: [
          PERMISSIONS.ANALYTICS_CUSTOMER_SEGMENTATION,
          PERMISSIONS.ANALYTICS_CUSTOMER_RETENTION_AND_CHURN,
        ],
        menuItems: [
          {
            path: "/analytics/customer-segmentation",
            title: "Customer Segmentation",
            permissions: [
              PERMISSIONS.ANALYTICS_CUSTOMER_SEGMENTATION,
              PERMISSIONS.ANALYTICS_CUSTOMER_SEGMENTATION_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/customer-retention-and-churn",
            title: "Customer Retention & Churn",
            permissions: [
              PERMISSIONS.ANALYTICS_CUSTOMER_RETENTION_AND_CHURN,
              PERMISSIONS.ANALYTICS_CUSTOMER_RETENTION_AND_CHURN_VISUALIZATION,
            ],
          },
        ],
      },
      {
        isGroup: true,
        title: "Risk Management",
        path: "risk-management-group",
        permissions: [PERMISSIONS.ANALYTICS_RISK_EXPOSURE_ASSESSMENT],
        menuItems: [
          {
            path: "/analytics/risk-exposure-assessment",
            title: "Risk Exposure Assessment",
            permissions: [PERMISSIONS.ANALYTICS_RISK_EXPOSURE_ASSESSMENT],
          },
        ],
      },
      {
        isGroup: true,
        title: "Operational Efficiency",
        path: "operational_efficiency",
        permissions: [
          PERMISSIONS.ANALYTICS_BRANCH_PERFORMANCE,
          PERMISSIONS.ANALYTICS_STAFF_PRODUCTIVITY,
        ],
        menuItems: [
          {
            path: "/analytics/branch-peformance",
            title: "Branch Performance",
            permissions: [
              PERMISSIONS.ANALYTICS_BRANCH_PERFORMANCE,
              PERMISSIONS.ANALYTICS_BRANCH_PERFORMANCE_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/staff-productivity",
            title: "Staff Productivity",
            permissions: [
              PERMISSIONS.ANALYTICS_STAFF_PRODUCTIVITY,
              PERMISSIONS.ANALYTICS_STAFF_PRODUCTIVITY_VISUALIZATION,
            ],
          },
        ],
      },
      {
        isGroup: true,
        title: "Savings & Deposits",
        path: "savings-deposits-group",
        permissions: [
          PERMISSIONS.ANALYTICS_SAVINGS_PRODUCTS_PERFORMANCE,
          PERMISSIONS.ANALYTICS_DEPOSIT_TRENDS,
        ],
        menuItems: [
          {
            path: "/analytics/savings-deposits/savings-product-performance",
            title: "Savings Product Performance",
            permissions: [PERMISSIONS.ANALYTICS_SAVINGS_PRODUCTS_PERFORMANCE],
          },
          {
            path: "/analytics/savings-deposits/deposit-trends",
            title: "Deposit Trends",
            permissions: [PERMISSIONS.ANALYTICS_DEPOSIT_TRENDS],
          },
        ],
      },
      {
        isGroup: true,
        title: "Revenue & Expenses",
        path: "revenue-expenses-group",
        permissions: [
          PERMISSIONS.ANALYTICS_REVENUE_PERFORMANCE,
          PERMISSIONS.ANALYTICS_REVENUE_PERFORMANCE_VISUAL,
          PERMISSIONS.ANALYTICS_EXPENSE_TRACKING,
          PERMISSIONS.ANALYTICS_EXPENSE_TRACKING_VISUAL,
          PERMISSIONS.ANALYTICS_PROFIT_MARGIN,
          PERMISSIONS.ANALYTICS_PROFIT_MARGIN_VISUAL,
        ],
        menuItems: [
          {
            path: "/analytics/revenue-performance-tracking",
            title: "Revenue Performance Tracking",
            permissions: [
              PERMISSIONS.ANALYTICS_REVENUE_PERFORMANCE,
              PERMISSIONS.ANALYTICS_REVENUE_PERFORMANCE_VISUAL,
            ],
          },
          {
            path: "/analytics/expense-tracking-analysis",
            title: "Expense Tracking & Analysis",
            permissions: [
              PERMISSIONS.ANALYTICS_EXPENSE_TRACKING,
              PERMISSIONS.ANALYTICS_EXPENSE_TRACKING_VISUAL,
            ],
          },
        ],
      },
      {
        isGroup: true,
        title: "Collection & Recovery",
        path: "collection-recovery-group",
        permissions: [
          PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_PERFORMANCE,
          PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_PERFORMANCE_VISUAL,
          PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_GOAL_SETTINGS,
          PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_GOAL_SETTINGS_VISUAL,
        ],
        menuItems: [
          {
            path: "/analytics/collection-officer-performance",
            title: "Collection Officer Performance",
            permissions: [
              PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_PERFORMANCE,
              PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_PERFORMANCE_VISUAL,
            ],
          },
          {
            path: "/analytics/collection-officer-goal-settings",
            title: "Collection Officer Goal Settings",
            permissions: [
              PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_GOAL_SETTINGS,
              PERMISSIONS.ANALYTICS_COLLECTION_OFFICER_GOAL_SETTINGS_VISUAL,
            ],
          },
        ],
      },
      {
        isGroup: true,
        title: "Product Performance",
        path: "product-performance-group",
        permissions: [
          PERMISSIONS.ANALYTICS_PRODUCT_PERFORMANCE,
          PERMISSIONS.ANALYTICS_PRODUCT_PERFORMANCE_VISUALIZATION,
          PERMISSIONS.ANALYTICS_CROSS_SELL,
          PERMISSIONS.ANALYTICS_CROSS_SELL_VISUALIZATION,
        ],
        menuItems: [
          {
            path: "/analytics/best-and-worst-performing-products",
            title: "Best and Worst Performing Products",
            permissions: [
              PERMISSIONS.ANALYTICS_PRODUCT_PERFORMANCE,
              PERMISSIONS.ANALYTICS_PRODUCT_PERFORMANCE_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/cross-sell-opportunities",
            title: "Cross-Sell Opportunities",
            permissions: [
              PERMISSIONS.ANALYTICS_CROSS_SELL,
              PERMISSIONS.ANALYTICS_CROSS_SELL_VISUALIZATION,
            ],
          },
        ],
      },
      {
        isGroup: true,
        title: "Loan Performance",
        path: "loan-perfomance-group",
        permissions: [
          PERMISSIONS.ANALYTICS_TOP_LOAN_PERFORMANCE,
          PERMISSIONS.ANALYTICS_LOAN_REPAYMENT,
          PERMISSIONS.ANALYTICS_LOAN_DELINQUENCY,
          PERMISSIONS.ANALYTICS_LOAN_PORTFOLIO,
        ],
        menuItems: [
          {
            path: "/analytics/loan-portfolio-analysis",
            title: "Loan Portfolio Analysis",
            permissions: [
              PERMISSIONS.ANALYTICS_LOAN_PORTFOLIO,
              PERMISSIONS.ANALYTICS_LOAN_PORTFOLIO_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/delinquency-rates",
            title: "Delinquency Rates",
            permissions: [
              PERMISSIONS.ANALYTICS_LOAN_DELINQUENCY,
              PERMISSIONS.ANALYTICS_LOAN_DELINQUENCY_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/loan-repayment-trends",
            title: "Loan Repayment Trends",
            permissions: [
              PERMISSIONS.ANALYTICS_LOAN_REPAYMENT,
              PERMISSIONS.ANALYTICS_LOAN_REPAYMENT_VISUALIZATION,
            ],
          },
          {
            path: "/analytics/top-performing-loans",
            title: "Top Performing loans",
            permissions: [
              PERMISSIONS.ANALYTICS_TOP_LOAN_PERFORMANCE,
              PERMISSIONS.ANALYTICS_TOP_LOAN_PERFORMANCE_VISUALIZATION,
            ],
          },
        ],
      },
    ],
  },
  {
    title: "System Settings",
    Icon: Icons.SettingsIcon,
    path: "/settings",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    categories: [
      MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
    ],
    permissions: [
      PERMISSIONS.ADD_BRANCH,
      PERMISSIONS.VIEW_BRANCH,
      PERMISSIONS.ADD_ROLES,
      PERMISSIONS.VIEW_ROLES,
      PERMISSIONS.ADD_STAFF,
      PERMISSIONS.VIEW_STAFF,
      PERMISSIONS.VIEW_LOAN_FEES,
      PERMISSIONS.VIEW_TRANSACTION_FEES,
      PERMISSIONS.VIEW_ACCOUNT_OPENING_FEES,
      PERMISSIONS.VIEW_LOAN_PRODUCTS,
      PERMISSIONS.VIEW_COLLATERAL_CATEGORIES,
      PERMISSIONS.VIEW_WORKING_HOURS_BRANCH,
      PERMISSIONS.VIEW_WORKING_HOURS_ROLE,
    ],
    subMenu: [
      {
        path: "/settings/bank-settings",
        title: "Institution Settings",
        users: [USER_TYPES.INSTITUTION_ADMIN],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/branches",
        title: "Branches",
        permissions: [PERMISSIONS.ADD_BRANCH, PERMISSIONS.VIEW_BRANCH],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/workflows",
        title: "Workflows",
        permissions: [PERMISSIONS.ADD_BRANCH, PERMISSIONS.VIEW_BRANCH],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/roles-and-permissions",
        title: "Roles & Permissions",
        permissions: [PERMISSIONS.ADD_ROLES, PERMISSIONS.VIEW_ROLES],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/staff",
        title: "Staff",
        permissions: [PERMISSIONS.ADD_STAFF, PERMISSIONS.VIEW_STAFF],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/staff-hierarchy-management",
        title: "Staff Hierarchy",
        permissions: [PERMISSIONS.ADD_STAFF_SUPERVISORS],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/collection-targets",
        title: "Collection Targets",
        permissions: [PERMISSIONS.ADD_STAFF, PERMISSIONS.VIEW_STAFF],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
      {
        path: "/settings/fees-settings",
        title: "Fees Settings",
        permissions: [
          PERMISSIONS.VIEW_LOAN_FEES,
          PERMISSIONS.ADD_LOAN_FEES,
          PERMISSIONS.VIEW_TRANSACTION_FEES,
          PERMISSIONS.ADD_TRANSACTION_FEES,
          PERMISSIONS.VIEW_ACCOUNT_OPENING_FEES,
          PERMISSIONS.ADD_ACCOUNT_OPENING_FEES,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/loan-settings",
        title: "Loan Settings",
        permissions: [
          PERMISSIONS.VIEW_LOAN_PRODUCTS,
          PERMISSIONS.ADD_LOAN_PRODUCTS,
          PERMISSIONS.VIEW_COLLATERAL_CATEGORIES,
          PERMISSIONS.ADD_COLLATERAL_CATEGORIES,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/forms-settings",
        title: "Forms Settings",
        permissions: [
          PERMISSIONS.VIEW_FORM_FIELD_CONFIGURATION,
          PERMISSIONS.ADD_FORM_FIELD_CONFIGURATION,
          PERMISSIONS.CHANGE_FORM_FIELD_CONFIGURATION,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/savings-settings",
        title: "Savings Settings",
        permissions: [
          PERMISSIONS.VIEW_SAVINGS_PRODUCTS,
          PERMISSIONS.ADD_SAVINGS_PRODUCTS,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/credit-score-settings",
        title: "Credit Score Settings",
        permissions: [
          PERMISSIONS.VIEW_SAVINGS_PRODUCTS,
          PERMISSIONS.ADD_SAVINGS_PRODUCTS,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/staff-portfolio",
        title: "Staff Portfolio Management",
        permissions: [
          PERMISSIONS.ADD_STAFF_PORTFOLIO_MANAGEMENT,
          PERMISSIONS.VIEW_STAFF_PORTFOLIO_MANAGEMENT,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/working-hours",
        title: "Working Hours",
        permissions: [
          PERMISSIONS.VIEW_WORKING_HOURS_BRANCH,
          PERMISSIONS.ADD_WORKING_HOURS_BRANCH,
          PERMISSIONS.EDIT_WORKING_HOURS_BRANCH,
          PERMISSIONS.VIEW_WORKING_HOURS_ROLE,
          PERMISSIONS.ADD_WORKING_HOURS_ROLE,
          PERMISSIONS.EDIT_WORKING_HOURS_ROLE,
        ],
        category: MenuCategories.SYSTEM_SETTINGS.OPERATIONAL,
      },
      {
        path: "/settings/general-settings",
        title: "General Settings",
        users: [USER_TYPES.INSTITUTION_ADMIN],
        category: MenuCategories.SYSTEM_SETTINGS.INSTITUTIONAL,
      },
    ],
  },
  {
    title: "Survey",
    Icon: Icons.AddReactionIcon,
    path: "/survey",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [],
    subMenu: [
      {
        title: "Templates",
        path: "/survey/survey-templates",
        permissions: [],
        users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
      },
    ],
  },
  {
    title: "Trash",
    Icon: Icons.DeleteIcon,
    path: "/trash",
    users: [USER_TYPES.INSTITUTION_ADMIN, USER_TYPES.STAFF],
    permissions: [],
    subMenu: [
      {
        isGroup: true,
        title: "Clients",
        path: "deleted-clients",
        permissions: [],
        menuItems: [
          {
            path: "/trash/deleted-clients-individual",
            title: "Individual",
            permissions: [],
          },
          {
            path: "/trash/deleted-clients-group",
            title: "Group",
            permissions: [],
          },
          {
            path: "/trash/deleted-clients-institution",
            title: "Institution",
            permissions: [],
          },
        ],
      },
      {
        isGroup: true,
        title: "Loan products",
        path: "deleted-loan-products",
        permissions: [],
        menuItems: [
          {
            path: "/trash/deleted-loan-products",
            title: "Loan products",
            permissions: [],
          },
        ],
      },
      {
        isGroup: true,
        title: "Savings Products",
        path: "deleted-savings-products",
        permissions: [],
        menuItems: [
          {
            path: "/trash/deleted-savings-products",
            title: "Savings Products",
            permissions: [],
          },
        ],
      },
      {
        isGroup: true,
        title: "Accounts",
        path: "deleted-accounts",
        permissions: [],
        menuItems: [
          {
            path: "/trash/deleted-accounts",
            title: "Accounts",
            permissions: [],
          },
        ],
      },
    ],
  },
  // SYSTEM USER ONLY
  {
    title: "Subscriptions",
    Icon: Icons.LoyaltyIcon,
    path: "/subscriptions",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
    subMenu: [
      {
        path: "/subscriptions/adhoc",
        title: "Adhoc Subscriptions",
        permissions: [],
      },
      {
        path: "/subscriptions/loan-agreement-credits",
        title: "Loan Agreement Credits",
        permissions: [],
      },
      {
        title: "System Billing",
        path: "/subscriptions/system-billing",
        permissions: [],
      },
      {
        path: "/subscriptions/crb-extraction-credit-purchases",
        title: " CRB Extraction Credit Purchases",
        permissions: [],
      },
    ],
  },
  {
    title: "Institutions",
    Icon: Icons.AccountBalanceIcon,
    path: "/all-banks",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "Institution Admins",
    Icon: Icons.SupervisorAccountIcon,
    path: "/all-banks-admin",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "Master Admins",
    Icon: Icons.SupervisorAccountIcon,
    path: "/master-admin",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "KYC Settings",
    Icon: Icons.PersonSearchIcon,
    path: "/kyc-settings",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "Packages",
    Icon: Icons.InventoryIcon,
    path: "/packages",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "Wallets Management",
    Icon: Icons.PaidIcon,
    path: "/zimba-wallet-management",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
  {
    title: "Usage Metrics",
    Icon: Icons.AddRoadIcon,
    path: "/usage-metrics",
    users: [USER_TYPES.SYSTEM_USER],
    permissions: [],
  },
];

export default MenuList;
